// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LiveChat-Main-Container {
  display: flex;
  height: 100%;
  
}

@media screen and (max-width: 1300px) {
  .LiveChat-Main-Container {
    max-width: 1200px;
    overflow-x: auto;
  }  
}


.ChatUser-Header-Container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.NoChat-Main-Container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.NoOngoing-Chat {
  color: #061522;
  text-align: center;

  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
  margin-top: 30px;
}
.NoOngoingChat01 {
  color: #405261;
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  width: 296px;
  margin-top: 8px;
}
.NoOngoing-Chat-Button {
  border-radius: 8px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #fff;
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  border: none;
  margin-top: 27px;
  padding: 11px 80px;
  cursor: pointer;
}
.NoOngoing-Chat-Button:hover {
  background-color: #0077cc;
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPages/LiveChat/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;;AAEd;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,WAAW;EACX,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,aAAa;AACf","sourcesContent":[".LiveChat-Main-Container {\n  display: flex;\n  height: 100%;\n  \n}\n\n@media screen and (max-width: 1300px) {\n  .LiveChat-Main-Container {\n    max-width: 1200px;\n    overflow-x: auto;\n  }  \n}\n\n\n.ChatUser-Header-Container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.NoChat-Main-Container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n.NoOngoing-Chat {\n  color: #061522;\n  text-align: center;\n\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n  margin-top: 30px;\n}\n.NoOngoingChat01 {\n  color: #405261;\n  text-align: center;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  width: 296px;\n  margin-top: 8px;\n}\n.NoOngoing-Chat-Button {\n  border-radius: 8px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #fff;\n  text-align: center;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  border: none;\n  margin-top: 27px;\n  padding: 11px 80px;\n  cursor: pointer;\n}\n.NoOngoing-Chat-Button:hover {\n  background-color: #0077cc;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
